import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext();

ModalContext.displayName = 'ModalContext';

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
    const [modalProps, setModalProps] = useState(null);

    const openModal = (props) => {
        setModalProps(props)
    }

    const closeModal = () => {
        setModalProps(null)
    }

    return (
        <ModalContext.Provider
            value={{
                modalProps,
                openModal,
                closeModal,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export default useModal
